import { GetCommCacheInput } from 'src/services/graphql/Models';

export default class GetCommCache {
    unitId: string;
    typedId: string;
    clientId?: string;
    fromTime?: number;
    toTime?: number;
    sinceDate?: Date;
    toPresent?: boolean;
    significantDifference: number;

    constructor(from: any) {
        if (
            isNaN(from.fromTime) && (
                typeof from.sinceDate === 'undefined' ||
                isNaN(from.sinceDate.getTime())
            )
        ) {
            throw new Error('Unknown Time');
        }
        Object.assign(this, from);
    }
    
    isRelated({typedId}: any) {
        return this.typedId === typedId;
    }

    updateComms(input: any) {
        let mutated = false;

        if ( 
            !isNaN(input.fromTime)
        ) {
            if ( 
                !isNaN(this.fromTime) 
            ) {
                if ( this.fromTime < input.fromTime ) {
                    this.fromTime = input.fromTime;
                    mutated = true;
                }       
            } else {
                this.fromTime = input.fromTime;
                mutated = true;
            }
        } else if (
            typeof (input.sinceDate)  !== 'undefined' &&
            (
                !isNaN(input.sinceDate.getTime()) ||
                !isNaN(input.sinceDate)
            )
        ) {
            if (
                typeof (this.sinceDate)  !== 'undefined' &&
                (
                    !isNaN(input.sinceDate.getTime()) ||
                    !isNaN(input.sinceDate)
                )
            ) {
                const sinceThis = this.sinceDate.getTime();
                const sinceInput = input.sinceDate.getTime();
                
                if ( sinceThis > sinceInput ) {
                    this.sinceDate = input.sinceDate;
                    mutated = true;
                }       
            } else {
                this.sinceDate = input.sinceDate;
                mutated = true;
            }
            
        } else {
            throw new Error('Incorrect fromTime');
        }

        if ( !this.toPresent && typeof input.toTime !== 'undefined') {
            let toTime;
            if (
                isNaN(input.toTime) &&
                typeof input.toTime.getTime === 'function'
            ) {
                toTime = input.toTime.getTime();
            } else if (
                !isNaN(input.toTime)
            ) {
                toTime = input.toTime;
            } 
            if (typeof toTime !== 'undefined') {
                if ( this.toTime > input.toTime ) {
                    this.toTime = input.toTime;
                    mutated = true;
                }
            }
        } 
        
        if (
            input.toPresent &&
            !this.toPresent
        ) {
            this.toPresent = input.toPresent;
            mutated = true;
        }
        
        return mutated;
    }

    getData(): GetCommCacheInput {
        let fromTime;
        if (!isNaN(this.fromTime))  {
            fromTime = Date.now() - this.fromTime;
        }
        
        if (this.sinceDate) {
            let sinceDate = this.sinceDate.getTime();            
            if (
                isNaN(fromTime) ||
                sinceDate < fromTime
            ) {
                fromTime = sinceDate;
            }
        }
        if (!fromTime) {
            throw new Error('Unknown Time While getting Date');
        }

        let toTime;
        if (this.toPresent) {
            toTime = Date.now();
        } else {
            toTime = this.toTime || Date.now();
        }

        fromTime -= Math.round(this.significantDifference * 60 * 1000 * 1.75);
        fromTime = Number.MAX_SAFE_INTEGER - fromTime;
        fromTime = fromTime.toString();
        toTime = Number.MAX_SAFE_INTEGER - toTime;
        toTime = toTime.toString();

        return {
            unitId: this.unitId,
            clientId: this.clientId,
            typedId: this.typedId,
            fromTime,
            toTime
        };
    }
}

// type CommSinceDate = {
//     sinceDate: Date
// };

// type CommFromTime = {
//     fromTime: number
// };

// type EitherComm = CommSinceDate | CommFromTime;

// type CommCacheInput =  EitherComm & {
//     unitId: string;
//     typedId: string;
//     clientId?: string;
//     toTime?: number;

// }



// WEBPACK FOOTER //
// ./src/shared/GetCommCache.ts